<template>
  <div>
    <div>
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Contents</v-card-title>
          <v-btn class="ml-auto" icon @click="close()">
            <v-icon small class="white--text">mdi-window-close</v-icon>
          </v-btn>
        </div>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="contents"
            :search="search"
            class="border"
            show-select
            :hide-default-footer="false"
            :single-select="singleSelect"
            v-model="selectedContent"
          >
            <template v-slot:[`item.created`]="{ item }">
              <div>
                {{ $moment(item.created_at).format("YYYY-MM-DD") }}
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { listContents } from "../graphql/Query";

export default {
  name: "CollectionContents",
  props: ["selected_contents"],
  components: {},
  data: () => ({
    // list
    search: "",
    channels: [],
    contents: [],
    selectedContent: [],
    singleSelect: false,
    headers: [
      {
        text: "Title",
        align: "start",
        value: "title"
      },

      { text: "Created", value: "created" }
    ],
    options: {}
  }),
  computed: {},
  mounted() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.contents = [];
      await this.getListContents();
      // 이미 선택된 목록 체크
      this.contents.forEach(item => {
        if (
          Array.isArray(this.selected_contents) &&
          this.selected_contents.find(contentId => contentId == item.id)
        ) {
          this.selectedContent.push(item);
        }
      });
    },
    close() {
      const selected = this.selectedContent.map(item => item.id);
      this.$emit("onCloseCollectionContentDialog", selected);
    },
    async getListContents() {
      // 채널 전체 컨텐츠가져오기
      const channel_id = this.$store.state.channelId;

      const { data } = await this.$apollo.query({
        query: listContents,
        variables: {
          channel_id: channel_id
        },
        fetchPolicy: "no-cache"
      });

      const items = data.listContents.items;
      console.log({ items });
      this.contents = items.filter(item => item.status == "COMPLETE");
      console.log("contents", this.contents);
    }
  }
};
</script>

<style></style>
